import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import Inspection_constants from "../Constants/InspectionConstants";

class Inspection_Actions {
  getAuftragRecord(_id) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/GetAuftragRecord/" + _id,
      "GET",
      null,

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Inspection_constants.GET_AUFTRAG_RECORD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Inspection_constants.GET_AUFTRAG_RECORD_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getNotPassedInspetion() {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/GetNotPassedInspections",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Inspection_constants.GET_NOTPASSED_INSPECTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Inspection_constants.GET_NOTPASSED_INSPECTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  updateInspectionRecord(Data) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/UpdateAuftragRecord",
      "PUT",
      JSON.stringify({
        ...Data,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Inspection_constants.UPDATE_RECORD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Inspection_constants.UPDATE_RECORD_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new Inspection_Actions();
